import React from 'react';
import type { StoreDto } from '../../../../offer.types';
import type { StoreContactDto } from '../../../../services/checkoutConfig/checkoutConfig.types';

interface StoreInformationSectionProps {
  store: StoreDto;
  contact: StoreContactDto;
  currentYear: number;
  showAddress: boolean;
  showCnpj: boolean;
  textColor: string;
}

export const StoreInformationSection: React.FC<StoreInformationSectionProps> = ({
  store,
  contact,
  currentYear,
  showAddress,
  showCnpj,
  textColor,
}) => {
  const address = showAddress ? contact.address : null;
  const cnpj = showCnpj ? (store.cnpj || contact.cnpj) : null;

  if (!address && !cnpj) return null;

  return (
    <div style={{ color: textColor }}>
      {address && (
        <div className="mb-2">
          <span className="text-sm">{address}</span>
        </div>
      )}

      {cnpj && (
        <div className="mb-3">
          <span className="text-sm">
            © {currentYear} {store.name} - CNPJ: {cnpj}
          </span>
        </div>
      )}
    </div>
  );
};
